'use client'

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'

export interface AccordionItem {
  title: string
  content: string
}

export const Accordion = ({ items }: { items: AccordionItem[] }) => {
  return (
    <div className="divide-y divide-black/5 rounded-xl">
      {items.map((item: AccordionItem, index) => (
        <Disclosure
          as="div"
          key={`${item.title}-${index}`}
          defaultOpen={items.length === 1}
          className="py-4"
        >
          {({ open }) => (
            <>
              <DisclosureButton className="flex w-full items-center justify-between">
                <span className="text-body-base font-medium">{item.title}</span>
                {open ? <MinusIcon className="size-6" /> : <PlusIcon className="size-6" />}
              </DisclosureButton>
              <DisclosurePanel
                dangerouslySetInnerHTML={{ __html: item.content }}
                className="prose pt-2"
              />
            </>
          )}
        </Disclosure>
      ))}
    </div>
  )
}
